//
// CursorChangeEvent.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "../events/PortableEvent";

var CursorChangeEvent = createModule("commons::CursorChangeEvent", ["commons::PortableEvent"], ClosetObject, [
    {
        CURSOR_CHANGE: 10012,
    },
    ,
    ,
    ,
    {
        getCursorShape: [4],
    },
    ,
    ,
]);
export default CursorChangeEvent;
